/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_ChartsInputs */



/**
* | output |
* | --- |
* | "Growth, engagement and audience charts" |
*
* @param {Pricing_Compare_ChartsInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_charts = /** @type {((inputs?: Pricing_Compare_ChartsInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_ChartsInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Графики роста, вовлечённости и аудитории")
	return /** @type {LocalizedString} */ ("Growth, engagement and audience charts")
});